import React from 'react';
import styled from 'styled-components';

const changeNumberToMilionAndKilo = (e) => {
    if (e >= 1000000) {
        return (e / 1000000).toFixed(0) + 'M+'
    }
    if (e >= 1000) {
        return (e / 1000).toFixed(0) + 'K+'
    }
    return e
}
const changeNumberToDecimal = (e) => {
    if (isNaN(e) === false && e > 0) {
        return e + '%+';
    }
    return e
}
const SpanWithChangeNumber = (e) => {
    const { max } = e
    if (max <= 100) {
        return (
            <span {...e}>
                {changeNumberToDecimal(e.children)}
            </span>
        )
    }
    return (
        <span {...e}>
            {changeNumberToMilionAndKilo(e.children)}
        </span>
    )
}
const SliderMax = (props) => {
    const { max } = props
    return (
        <SliderMaxWrap>
            <span>{0}</span>
            <SpanWithChangeNumber max={max}>{max}</SpanWithChangeNumber>
        </SliderMaxWrap>
    )
}
export default SliderMax;

const SliderMaxWrap = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    font-size: 10px;
    font-weight: 300;
    color: #A0A0A0;
`


// WEBPACK FOOTER //
// ./src/InfoList/Search/dev/SliderBarSearch/SliderMax.js